import { Link } from "react-router-dom"
import {DivVercel, Li} from "./style"
import {BsArrowRightShort} from "react-icons/bs"
import { AiFillGithub } from "react-icons/ai"

const Project = ({project}) =>{
    const {name,latestDeployments} = project
    const url = latestDeployments[0]
    const {alias}  = url
    const domains = alias[0]
    

    return(
        <>
        <Li>
            <p>Nome: {name}</p>
            <iframe src={`https://${domains}`} scrolling="no"></iframe>
            <DivVercel>
                <a href={`https://github.com/pedrohtbl/${name}`} target="_blank"> <AiFillGithub/>  Repositório</a>
                <a href={`https://${domains}`} target="_blank">Saiba mais <BsArrowRightShort/></a>
            </DivVercel>
          
        </Li>
        </>
    )
}

export default Project